import { ref } from 'vue'
import { defineStore } from 'pinia'
import { dismissedExpertiseFeedbackApi } from '@src/api/apiModuleInstances'

export const useDismissedExpertiseFeedback = defineStore('dismissedExpertiseFeedback', () => {
  const dismissedExpertiseFeedbacks = ref<number[]>([])

  async function loadDismissedExpertiseFeedback() {
    try {
      const { data } = await dismissedExpertiseFeedbackApi.getDismissed()
      dismissedExpertiseFeedbacks.value = data
    } catch (e) {
      console.log(e)
    }
  }

  async function dismissExpertiseFeedback(questionId: number) {
    await dismissedExpertiseFeedbackApi.dismiss(questionId)
    loadDismissedExpertiseFeedback()
  }

  return {
    dismissedExpertiseFeedbacks,
    loadDismissedExpertiseFeedback,
    dismissExpertiseFeedback
  }
})
